/**
 * LONGEVIDAYS — Interactive behaviors v2
 * Hero slider, product card carousel, scroll reveal, video, waitlist modal
 */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll Reveal ──────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.ld-reveal');
    if (!els.length) return;

    function revealAll() {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* Hareket azaltma tercihi veya IntersectionObserver yoksa hemen goster */
    if (prefersReduced || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      /* threshold 0: elemandan tek piksel bile gorununce tetikle.
         Mobilde tek kolona inen uzun bolumler ekran boyundan buyuk
         oldugu icin 0.15 esigi asla saglanmiyordu ve bolum bos/beyaz kaliyordu. */
      threshold: 0,
      rootMargin: '0px 0px -5% 0px'
    });
    els.forEach(function (el) { observer.observe(el); });

    /* Guvenlik agi: gozlemci herhangi bir nedenle tetiklenmezse
       2 sn sonra her seyi gorunur yap, icerik asla bos kalmasin. */
    setTimeout(revealAll, 2000);
  }

  /* ── Hero Slider ────────────────────────────────────── */
  function initHeroSlider() {
    var hero = document.querySelector('[data-ld-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('.ld-hero__slide');
    var dots = hero.querySelectorAll('[data-ld-hero-dot]');
    var prevBtn = hero.querySelector('[data-ld-hero-prev]');
    var nextBtn = hero.querySelector('[data-ld-hero-next]');
    var speed = parseInt(hero.dataset.autoplay, 10) * 1000 || 6000;
    var current = 0;
    var timer = null;
    var paused = false;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
        dots[current].setAttribute('tabindex', '-1');
      }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
        dots[current].setAttribute('tabindex', '0');
      }
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAutoplay() {
      if (timer) clearInterval(timer);
      if (prefersReduced) return;
      timer = setInterval(function () { if (!paused) next(); }, speed);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.ldHeroDot, 10));
        startAutoplay();
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    hero.addEventListener('mouseenter', function () { paused = true; });
    hero.addEventListener('mouseleave', function () { paused = false; });
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); startAutoplay(); }
      if (e.key === 'ArrowRight') { next(); startAutoplay(); }
    });
    if (slides.length > 1) startAutoplay();
  }

  /* ── Product Card 2-Slide Carousel ──────────────────── */
  function initProductCards() {
    var cards = document.querySelectorAll('[data-ld-card]');
    cards.forEach(function (card) {
      var slides = card.querySelectorAll('[data-ld-card-slide]');
      var dots = card.querySelectorAll('[data-ld-card-dot]');
      if (slides.length < 2) return;

      var currentSlide = 0;
      var hoverTimer = null;
      var autoTimer = null;

      function showSlide(idx) {
        slides[currentSlide].classList.remove('is-active');
        dots[currentSlide].classList.remove('is-active');
        currentSlide = idx;
        slides[currentSlide].classList.add('is-active');
        dots[currentSlide].classList.add('is-active');
      }

      /* Desktop: hover with 200ms delay */
      card.addEventListener('mouseenter', function () {
        hoverTimer = setTimeout(function () { showSlide(1); }, 200);
      });
      card.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        showSlide(0);
      });

      /* Dot clicks */
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          showSlide(i);
        });
      });

      /* Mobile: auto cycle when visible (4s interval) */
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        if (prefersReduced) return;
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              autoTimer = setInterval(function () {
                showSlide(currentSlide === 0 ? 1 : 0);
              }, 4000);
            } else {
              clearInterval(autoTimer);
              showSlide(0);
            }
          });
        }, { threshold: 0.5 });
        observer.observe(card);
      }
    });
  }

  /* ── Add to Cart ────────────────────────────────────── */
  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ld-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            /* Stok yetersizse Shopify 422 doner */
            var err = new Error('Cart error');
            err.soldOut = res.status === 422;
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        btn.textContent = 'Eklendi!';

        /* Fetch updated cart drawer HTML via Section Rendering API */
        fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            /* Update cart drawer content */
            if (sections['cart-drawer']) {
              var drawerEl = document.querySelector('cart-drawer');
              if (drawerEl) {
                var tmp = document.createElement('div');
                tmp.innerHTML = sections['cart-drawer'];
                var newDrawer = tmp.querySelector('cart-drawer');
                if (newDrawer) {
                  drawerEl.innerHTML = newDrawer.innerHTML;
                  drawerEl.classList.remove('is-empty');
                }
              }
            }
            /* Update cart icon bubble count */
            if (sections['cart-icon-bubble']) {
              var bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
              if (bubbleSection) {
                bubbleSection.innerHTML = sections['cart-icon-bubble'];
              }
            }

            /* Update header cart count */
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var counters = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]');
                counters.forEach(function (el) { el.textContent = cart.item_count; });
                var bubbles = document.querySelectorAll('.cart-count-bubble');
                bubbles.forEach(function (b) {
                  if (cart.item_count > 0) b.removeAttribute('hidden');
                  b.style.display = cart.item_count > 0 ? '' : 'none';
                });
              })
              .catch(function () {});

            /* Open cart drawer */
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                cartDrawer.classList.add('active');
                cartDrawer.querySelector('.drawer')?.classList.add('active');
                document.body.classList.add('overflow-hidden');
              }
            }
          })
          .catch(function () {});

        setTimeout(function () {
          btn.textContent = '+Ekle';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        if (err && err.soldOut) {
          /* Stok tukendi: hata gosterme, sadece bilgilendir ve butonu kapat */
          btn.textContent = 'Stok Tukendi';
          btn.classList.add('ld-product-card__add--sold-out');
          return;
        }
        btn.textContent = 'Hata!';
        setTimeout(function () {
          btn.textContent = '+Ekle';
          btn.disabled = false;
        }, 1500);
      });
    });
  }

  /* ── Hero Video ─────────────────────────────────────── */
  function initHeroVideo() {
    var wrapper = document.querySelector('[data-ld-video]');
    if (!wrapper) return;
    var video = wrapper.querySelector('[data-ld-video-el]');
    var poster = wrapper.querySelector('[data-ld-video-poster]');
    var muteBtn = wrapper.querySelector('[data-ld-video-mute]');
    var ctaBtn = wrapper.querySelector('[data-ld-video-cta]');

    if (video) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
            if (poster) poster.classList.add('is-hidden');
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 });
      observer.observe(video);
    }
    if (muteBtn && video) {
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        this.setAttribute('aria-label', video.muted ? 'Sesi ac' : 'Sesi kapat');
      });
    }
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('ld-bestsellers');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* ── Mini Videos ────────────────────────────────────── */
  function initMiniVideos() {
    document.querySelectorAll('[data-ld-mini-video]').forEach(function (w) {
      var vid = w.querySelector('video');
      if (!vid) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) vid.play().catch(function () {});
          else vid.pause();
        });
      }, { threshold: 0.3 });
      observer.observe(vid);
    });
  }

  /* ── Waitlist Modal ─────────────────────────────────── */
  function initWaitlistModal() {
    var openBtns = document.querySelectorAll('[data-ld-waitlist-open]');
    var modal = document.querySelector('[data-ld-waitlist-modal]');
    if (!modal) return;
    var closeBtns = modal.querySelectorAll('[data-ld-waitlist-close]');
    var form = modal.querySelector('[data-ld-waitlist-form]');
    var formWrap = modal.querySelector('[data-ld-waitlist-form-wrap]');
    var success = modal.querySelector('[data-ld-waitlist-success]');
    var previouslyFocused = null;

    function open() {
      previouslyFocused = document.activeElement;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var input = modal.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus(); }, 100);
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (previouslyFocused) previouslyFocused.focus();
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    /* Focus trap */
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('button[type="submit"]');
        var emailInput = form.querySelector('input[type="email"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '...'; }
        if (emailInput) emailInput.disabled = true;

        /* TODO: Replace with actual API call — POST /api/waitlist */
        setTimeout(function () {
          if (formWrap) formWrap.style.display = 'none';
          if (success) success.classList.add('is-visible');
        }, 600);
      });
    }
  }

  /* ── Init ───────────────────────────────────────────── */
  function init() {
    initReveal();
    initHeroSlider();
    initProductCards();
    initAddToCart();
    initHeroVideo();
    initMiniVideos();
    initWaitlistModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
